import { DefaultApolloClient, provideApolloClient } from '@vue/apollo-composable'
import { ApolloClient, InMemoryCache, from, HttpLink, ApolloLink } from '@apollo/client/core'
import { RetryLink } from '@apollo/client/link/retry'

import { onError } from '@apollo/client/link/error'
import loggerLink from '@utils/apolloLoggerLink'

export default defineNuxtPlugin(nuxtApp => {
  const uri = process.env.VITE_API_ENDPOINT
  const httpLink = new HttpLink({ uri })

  const authMiddleware = new ApolloLink((operation, forward) => {
    const tokens = getTokens()
    const authorization = tokens?.access ? `Bearer ${tokens.access}` : ''

    operation.setContext(({ headers = {} }) => ({
      headers: {
        ...headers,
        authorization
      }
    }))

    return forward(operation)
  })

  const retryLink = new RetryLink({
    delay: {
      initial: 300,
      max: 5000,
      jitter: true
    },
    attempts: {
      max: 5,
      retryIf: (error: unknown) => !!error
    }
  })

  const errorLink = onError(error => {
    nuxtApp.callHook('apollo:error', error)
  })

  const link = from([authMiddleware, loggerLink, errorLink, retryLink, httpLink])
  const cache = new InMemoryCache()

  const apolloClient = new ApolloClient({
    link,
    cache
  })

  nuxtApp.vueApp.provide(DefaultApolloClient, apolloClient)
  provideApolloClient(apolloClient)
})
